// PRX-24667: while a Revolut Pay attempt is in progress the amount and the
// currency are locked (the order is being created for them).
const NATIVE_SDK_LOCKED_PAY_DATA = ['amount', 'totalCharge', 'currency'];
const isNativeSdkPayDataLocked = (state) => !!state.nativeSdk?.isPaymentInProgress;
const withoutLockedPayData = (state, payload) => {
  if (!isNativeSdkPayDataLocked(state) || !payload || typeof payload !== 'object') return payload;
  const allowed = { ...payload };
  NATIVE_SDK_LOCKED_PAY_DATA.forEach((key) => delete allowed[key]);
  return allowed;
};

const changePayData = (state, action) => {
  if (state === undefined) {
    return {};
  }

  const layout = state.initTheme?.theme_editor_settings?.customization_settings?.layout;

  switch (action.type) {
    case 'RESET_TAB_STATE':
      return {};
    case 'CREATE_CURRENT_GATEWAY':
      if (layout === 'amount-first') {
        return state.payData;
      }
      return {};
    case 'INIT_METHOD_STATE':
      if (layout === 'amount-first') {
        const fields = { ...action.payload.fields };
        delete fields.label;
        delete fields.data;
        delete fields.isManual;
        delete fields.__typename;
        const prevPayData = state.payData || {};
        const {
          amount,
          currency,
          totalCharge,
          promocode,
          dod_acknowledgement_required,
          base_amount,
          base_currency,
          email,
          isEditingPaymentCurrency,
        } = prevPayData;
        return {
          amount,
          currency,
          totalCharge,
          promocode,
          dod_acknowledgement_required,
          base_amount,
          base_currency,
          email,
          ...fields,
          amount: fields.amount || amount,
          currency: fields.currency || currency,
          totalCharge: fields.totalCharge || totalCharge,
          promocode: fields.promocode || promocode,
          base_amount: base_amount || null,
          dod_acknowledgement_required:
            dod_acknowledgement_required ?? fields.dod_acknowledgement_required,
          isEditingPaymentCurrency,
        };
      }
      return action.payload.fields;
    case 'CHANGE-PAY-DATA':
      return {
        ...state.payData,
        ...withoutLockedPayData(state, action.payload),
      };
    case 'UPDATE-PAY-DATA':
      if (
        isNativeSdkPayDataLocked(state) &&
        NATIVE_SDK_LOCKED_PAY_DATA.includes(action.payload?.name)
      ) {
        return state.payData;
      }
      return {
        ...state.payData,
        [action.payload.name]: action.payload.value,
      };
    case 'SET_EDITING_PAYMENT_CURRENCY':
      return {
        ...state.payData,
        isEditingPaymentCurrency: action.payload,
      };
    case 'APPLY_TEMPLATE':
      const isEmptyTemplate = !action.payload?.value;

      const emptyTemplateObject = Object.fromEntries(
        Object.keys(state.payInfo?.template).map((key) => [key, '']),
      );

      return {
        ...state.payData,
        ...(isEmptyTemplate ? emptyTemplateObject : {}),
      };
    default:
      return state.payData;
  }
};

export { changePayData };
